import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
type CountdownTimerProps = {
  label?: string;
};
export function CountdownTimer({
  label = 'L’offerta speciale termina tra:'
}: CountdownTimerProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const blocks = [{
    value: pad(hours),
    label: 'ORE'
  }, {
    value: pad(minutes),
    label: 'MIN'
  }, {
    value: pad(seconds),
    label: 'SEC'
  }];
  return <div className="w-full" data-id="element-17" data-mp="34oe72ptho471">
      <p className="mb-2.5 text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-gold-light" data-id="element-18" data-mp="2zr5ncksozs3o">
        {label}
      </p>
      <div className="flex items-center justify-center gap-1.5" role="timer" aria-live="off" aria-label={`Offerta valida ancora ${hours} ore ${minutes} minuti ${seconds} secondi`} data-id="element-19" data-mp="1bz3u2p7shyrt">
        {blocks.map((block, index) => <React.Fragment key={block.label} data-id="element-20" data-mp="1712b04ad5zgc" data-mpi={index}>
            {index > 0 ? <span className="font-display text-2xl font-bold text-gold/50" data-id="element-21" data-mp="1ur6dg8btft5r">
                :
              </span> : null}
            <div className="flex min-w-[64px] flex-col items-center rounded-xl border border-gold/30 bg-ink px-2 py-2 sm:min-w-[78px]" data-id="element-22" data-mp="1zp7vqr1f3og6">
              <span className="font-display text-[26px] font-bold tabular-nums leading-none text-cream sm:text-3xl" data-id="element-23" data-mp="1l13dtpa6vgyg">
                {block.value}
              </span>
              <span className="mt-1 text-[9px] font-bold tracking-[0.16em] text-cream/50" data-id="element-24" data-mp="2dozef52vpt0i">
                {block.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}